import { render } from "./SidebarSection.vue?vue&type=template&id=46cf3c09&scoped=true"
import script from "./SidebarSection.vue?vue&type=script&lang=js"
export * from "./SidebarSection.vue?vue&type=script&lang=js"

import "./SidebarSection.vue?vue&type=style&index=0&id=46cf3c09&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46cf3c09"]])

export default __exports__